import Heading from '@atlaskit/heading';
import { Inline, Stack } from '@atlaskit/primitives';

import { useCreateFlowSession } from '../hooks/use-create-flow';
import { LayoutBoysenberry } from '../layout-boysenberry';
import { Form } from '../shared/components/create-flow-form';
import { useDarkMode } from '../utils/use-dark-mode';
import { usePageTitle } from '../utils/use-page-title';

export const BoysenberryCreateEmbedPage = () => {
	useDarkMode();
	usePageTitle('Create new flow');

	const [createFlowSession, isCreatingFlow] = useCreateFlowSession();

	const handleSubmit = (repositoryUrl: string, branchName: string, prompt: string) => {
		createFlowSession({
			repoUrl: repositoryUrl,
			branchName,
			prompt,
			onSuccess: () => {
				window.parent.postMessage('boysenberryCreateSuccess', '*');
			},
		});
	};
	const currentUrl = decodeURIComponent(document.location.search.split('currentUrl=')[1]);

	const initialRepositoryUrl = currentUrl.includes('bitbucket.org')
		? `${currentUrl}`.split('/').slice(0, 5).join('/')
		: null;

	return (
		<LayoutBoysenberry>
			<Stack space="space.300">
				<Inline alignBlock="center" spread="space-between" grow="fill" shouldWrap>
					<Heading size="small">Create new flow</Heading>
				</Inline>
				<Form
					initialBranchName="issue-123-my-feature"
					initialRepositoryUrl={initialRepositoryUrl}
					isCreatingFlow={isCreatingFlow}
					onCancel={() => {
						window.parent.postMessage('boysenberryCreateCancel', '*');
					}}
					onSubmit={handleSubmit}
				/>
			</Stack>
		</LayoutBoysenberry>
	);
};
